import { render } from "./CarriersStats.vue?vue&type=template&id=3332c03b&scoped=true"
import script from "./CarriersStats.vue?vue&type=script&lang=js"
export * from "./CarriersStats.vue?vue&type=script&lang=js"

import "./CarriersStats.vue?vue&type=style&index=0&id=3332c03b&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3332c03b"]])

export default __exports__